import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";



@Injectable()
export class DataService {
  private dataPersonSearch = new BehaviorSubject(null);
  currentPersonSearchData = this.dataPersonSearch.asObservable();

  private dataPersonSearchForm = new BehaviorSubject(null);
  currentPersonSearchFormData = this.dataPersonSearchForm.asObservable();

  private dataBusinessSearch = new BehaviorSubject(null);
  currentBusinessSearchData = this.dataBusinessSearch.asObservable();

  private dataBusinessSearchForm = new BehaviorSubject(null);
  currentBusinessSearchFormData = this.dataBusinessSearchForm.asObservable();

  private dataIdentityCheck = new BehaviorSubject(null);
  currentIdentityCheckData = this.dataIdentityCheck.asObservable();

  private dataIdentityCheckForm = new BehaviorSubject(null);
  currentIdentityCheckFormData = this.dataIdentityCheckForm.asObservable();

  private dataDocumentCheck = new BehaviorSubject(null);
  currentDocumentCheckData = this.dataDocumentCheck.asObservable();

  private dataDocumentCheckForm = new BehaviorSubject(null);
  currentDocumentCheckFormData = this.dataDocumentCheckForm.asObservable();

  private dataMrzCheck = new BehaviorSubject(null);
  currentMrzCheckData = this.dataMrzCheck.asObservable();

  private dataMrzCheckForm = new BehaviorSubject(null);
  currentMrzCheckFormData = this.dataMrzCheckForm.asObservable();

  private dataAccountsDetails = new BehaviorSubject(null);
  currentAccountsDetailsData = this.dataAccountsDetails.asObservable();

  private dataAdhocPaymentTransactionId = new BehaviorSubject(null);
  currentAdhocPaymentTransactionId = this.dataAdhocPaymentTransactionId.asObservable();

  constructor() { }

  setPersonSearchData(data: any) {
    this.dataPersonSearch.next(data);
  }

  setPersonSearchFormData(data: any) {
    this.dataPersonSearchForm.next(data);
  }

  setBusinessSearchData(data: any) {
    this.dataBusinessSearch.next(data);
  }

  setBusinessSearchFormData(data: any) {
    this.dataBusinessSearchForm.next(data);
  }

  setIdentityCheckData(data: any) {
    this.dataIdentityCheck.next(data);
  }

  setIdentityCheckFormData(data: any) {
    this.dataIdentityCheckForm.next(data);
  }

  setDocumentCheckData(data: any) {
    this.dataDocumentCheck.next(data);
  }

  setDocumentCheckFormData(data: any) {
    this.dataDocumentCheckForm.next(data);
  }

  setMrzCheckData(data: any) {
    this.dataMrzCheck.next(data);
  }

  setMrzCheckFormData(data: any) {
    this.dataMrzCheckForm.next(data);
  }

  setAccountsDetailsData(data: any) {
    this.dataAccountsDetails.next(data);
  }

  setAdhocPaymentTransactionId(data: any) {
    this.dataAdhocPaymentTransactionId.next(data);
  }


}
